import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../api/axios';
import { LayoutDashboard, GraduationCap, Users, BarChart3, LogOut, ChevronLeft, ChevronRight, Menu, X, Tag, Newspaper, Settings, CalendarDays, ClipboardList, CheckSquare, FileText, FileCheck, ChevronDown } from 'lucide-react';

const menuItems = [
  { icon: LayoutDashboard, label: 'Ana Sayfa', path: '/yonetim' },
  { icon: GraduationCap, label: 'Eğitimler', path: '/yonetim/egitimler' },
  { icon: Users, label: 'Kullanıcılar', path: '/yonetim/kullanicilar' },
    { icon: BarChart3, label: 'Raporlar', path: '/yonetim/raporlar' },
  { icon: Users, label: 'Eğitim Atama', path: '/yonetim/egitim-atama' },
  { icon: Tag, label: 'Kategoriler', path: '/yonetim/kategoriler' },
  { icon: CalendarDays, label: 'Takvim', path: '/yonetim/takvim' },
    { icon: FileCheck, label: 'Belge Takibi', path: '/yonetim/belge-takibi' },
  { icon: ClipboardList, label: 'Anket Sonuçları', path: '/yonetim/anket-sonuclari' },
  { icon: FileText, label: 'Form Yöneticisi', path: '/yonetim/formlar' },
  { icon: CheckSquare, label: 'Görev Yönetimi', path: '/yonetim/gorevler', children: [
    { label: 'Panel', path: '/yonetim/gorevler' },
    { label: 'Kanban Panosu', path: '/yonetim/gorevler/kanban' },
    { label: 'Projeler', path: '/yonetim/gorevler/projeler' },
    { label: 'Görev Listesi', path: '/yonetim/gorevler/liste' },
    { label: 'Gantt', path: '/yonetim/gorevler/gantt' },
    { label: 'Raporlar', path: '/yonetim/gorevler/raporlar' },
    { label: 'Ayarlar', path: '/yonetim/gorevler/ayarlar' },
  ]},
  { icon: Newspaper, label: 'Faaliyetler', path: '/yonetim/faaliyetler' },
];

export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [openMenus, setOpenMenus] = useState(() => {
    const initial = {};
    menuItems.forEach(item => {
      if (item.children && (item.children.some(c => typeof window !== 'undefined' && window.location.pathname === c.path) || (typeof window !== 'undefined' && window.location.pathname.startsWith(item.path)))) {
        initial[item.path] = true;
      }
    });
    return initial;
  });
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [profileForm, setProfileForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [profileMsg, setProfileMsg] = useState('');
  const [savingProfile, setSavingProfile] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Mobil Kontrolü
  useEffect(() => {
    const handler = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) setMobileOpen(false);
    };
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

        // AKILLI MENÜ HAFIZASI
  useEffect(() => {
    setOpenMenus(prev => {
      let hasChanges = false;
      const next = { ...prev };
      menuItems.forEach(item => {
        if (item.children && (item.children.some(c => location.pathname === c.path) || location.pathname.startsWith(item.path))) {
          if (!next[item.path]) {
            next[item.path] = true;
            hasChanges = true;
          }
        }
      });
      return hasChanges ? next : prev;
    });
  }, [location.pathname]);

  const handleLogout = () => setShowLogoutConfirm(true);
  const doLogout = () => { logout(); navigate('/giris'); };

  const SidebarContent = () => (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', background: '#ffffff', borderRight: '1px solid #eaecf0' }}>
      {/* Logo Alanı */}
      <div style={{ padding: '20px 16px 16px', display: 'flex', alignItems: 'center', gap: 12, minHeight: 70, borderBottom: '1px solid #f2f4f7' }}>
        <div style={{ height: 40, width: 40, background: '#ffffff', border: '1px solid #eaecf0', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, boxShadow: '0 2px 6px rgba(16,24,40,0.04)' }}>
          <img src="/favicon.ico" alt="Petlas" style={{ width: 22, height: 22, objectFit: 'contain' }} onError={e => { e.target.src='/uploads/assets/logo.png'; e.target.style.width='28px'; e.target.style.height='28px'; }} />
        </div>
        {(!collapsed || isMobile) && (
          <div style={{ overflow: 'hidden', whiteSpace: 'nowrap' }}>
            <div style={{ fontWeight: 700, fontSize: 13, color: '#101828', lineHeight: 1.2 }}>Eğitim & Akademi</div>
            <div style={{ fontSize: 11, color: '#667085', fontWeight: 500, marginTop: 2 }}>Yönetim Paneli</div>
          </div>
        )}
        {!isMobile && (
          <button className="sidebar-toggle-btn" onClick={() => setCollapsed(!collapsed)} title={collapsed ? "Genişlet" : "Daralt"}>
            {collapsed ? <ChevronRight size={15} /> : <ChevronLeft size={15} />}
          </button>
        )}
        {isMobile && (
          <button className="sidebar-toggle-btn" onClick={() => setMobileOpen(false)}>
            <X size={16} />
          </button>
        )}
      </div>

      {/* Menü Başlığı */}
      {(!collapsed || isMobile) && (
        <div style={{ padding: '16px 16px 8px', fontSize: 11, fontWeight: 700, color: '#98a2b3', letterSpacing: 1.2, textTransform: 'uppercase' }}>Yönetim</div>
      )}

      {/* Navigasyon */}
      <nav className="sidebar-nav" style={{ flex: 1, padding: '8px 12px', overflowY: 'auto' }}>
        {menuItems.map(item => {
          const active = location.pathname === item.path;
          const parentActive = item.path === '/yonetim' 
            ? active 
            : (location.pathname.startsWith(item.path + '/') || location.pathname === item.path);
            
          const Icon = item.icon;
          const isCurrentPath = item.children && (item.children.some(c => location.pathname === c.path) || location.pathname.startsWith(item.path));
          const isOpen = openMenus[item.path] || isCurrentPath;

          return (
            <div key={item.path}>
              <div
                className={`petlas-menu-item ${parentActive ? 'active' : ''} ${collapsed && !isMobile ? 'collapsed' : ''}`}
                onClick={() => {
                  if (item.children) {
                    setOpenMenus(prev => ({...prev, [item.path]: !prev[item.path]}));
                  } else {
                    navigate(item.path);
                    if (isMobile) setMobileOpen(false);
                  }
                }}
              >
                {/* Sadece bu dikey çizgi kırmızı kalacak */}
                {parentActive && <div className="active-indicator" />}

                <div className="petlas-menu-icon">
                  <Icon size={18} strokeWidth={parentActive ? 2.2 : 1.8} />
                </div>

                {(!collapsed || isMobile) && <span className="petlas-menu-label">{item.label}</span>}

                {(!collapsed || isMobile) && item.children && (
                  <ChevronDown size={14} className={`submenu-chevron ${isOpen ? 'open' : ''}`} />
                )}
              </div>

              {/* Alt Menü */}
              {(!collapsed || isMobile) && item.children && (
                <div className="petlas-submenu-container" style={{ display: (openMenus[item.path] || location.pathname.startsWith(item.path)) ? 'block' : 'none', transform: 'translateZ(0)', backfaceVisibility: 'hidden', willChange: 'transform' }}>
                  {item.children.map(child => {
                    const childActive = location.pathname === child.path;
                    return (
                      <div key={child.path} className={`petlas-submenu-item ${childActive ? 'active' : ''}`} onClick={() => { navigate(child.path); if (isMobile) setMobileOpen(false); }}>
                        <div className="submenu-dot" />
                        {child.label}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </nav>

      {/* Footer / Kullanıcı & Çıkış */}
      <div style={{ padding: '12px', borderTop: '1px solid #eaecf0', background: '#fcfcfd' }}>
        {(!collapsed || isMobile) && (
          <div className="sidebar-user-card">
            <div className="sidebar-user-avatar">
              {user?.name?.charAt(0).toUpperCase()}
            </div>
            <div style={{ minWidth: 0, flex: 1 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#101828', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user?.name}</div>
              <div style={{ fontSize: 11, color: '#667085', marginTop: 2 }}>Yönetici</div>
            </div>
          </div>
        )}
        <div className="sidebar-logout-btn" onClick={handleLogout}>
          <div className="logout-icon-wrapper">
            <LogOut size={18} strokeWidth={1.8} />
          </div>
          {(!collapsed || isMobile) && <span>Çıkış Yap</span>}
        </div>
      </div>
    </div>
  );

  const changePassword = async () => {
    if (!profileForm.currentPassword || !profileForm.newPassword) { setProfileMsg('Tüm alanlar zorunlu'); return; }
    if (profileForm.newPassword !== profileForm.confirmPassword) { setProfileMsg('Yeni şifreler eşleşmiyor'); return; }
    if (profileForm.newPassword.length < 6) { setProfileMsg('Şifre en az 6 karakter olmalı'); return; }
    setSavingProfile(true); setProfileMsg('');
    try {
      await api.post('/users/' + user.id + '/change-password', { password: profileForm.newPassword, currentPassword: profileForm.currentPassword });
      setProfileMsg('✓ Şifre başarıyla değiştirildi');
      setProfileForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
    } catch(e) { setProfileMsg('Hata: Mevcut şifre yanlış olabilir'); }
    setSavingProfile(false);
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f9fafb' }}>
      {isMobile && mobileOpen && (
        <div onClick={() => setMobileOpen(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(16,24,40,0.5)', zIndex: 299, backdropFilter: 'blur(4px)', transition: 'all 0.3s' }} />
      )}

      {!isMobile && (
        <div style={{ width: collapsed ? 72 : 260, flexShrink: 0, transition: 'width 0.3s cubic-bezier(0.2, 0, 0, 1)', position: 'sticky', top: 0, height: '100vh', zIndex: 20 }}>
          <SidebarContent />
        </div>
      )}

      {isMobile && (
        <div style={{ position: 'fixed', left: mobileOpen ? 0 : -280, top: 0, bottom: 0, width: 280, zIndex: 300, transition: 'left 0.3s cubic-bezier(0.2, 0, 0, 1)', boxShadow: mobileOpen ? '12px 0 32px rgba(16,24,40,0.08)' : 'none' }}>
          <SidebarContent />
        </div>
      )}

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minWidth: 0 }}>
        {/* Topbar */}
        <div className="admin-topbar">
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {isMobile && (
              <button className="mobile-menu-btn" onClick={() => setMobileOpen(true)}>
                <Menu size={20} />
              </button>
            )}
            {isMobile && <span style={{ fontWeight: 700, fontSize: 16, color: '#101828' }}>Petlas Eğitim</span>}
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button className="topbar-refresh-btn" onClick={() => window.location.reload()} title="Sayfayı Yenile">⟳</button>

            <div style={{ position: 'relative' }} className="admin-user-menu">
              <div className="topbar-user-card" onClick={() => setUserMenuOpen(prev => !prev)}>
                <div className="topbar-user-avatar">
                  {user?.name?.charAt(0).toUpperCase()}
                </div>
                <div className="hide-on-mobile">
                  <div style={{ fontWeight: 600, fontSize: 13, color: '#344054' }}>{user?.name}</div>
                </div>
                <ChevronDown size={14} color="#667085" style={{ transform: userMenuOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.3s cubic-bezier(0.2, 0, 0, 1)' }} />
              </div>

              {userMenuOpen && (
                <div className="topbar-dropdown">
                  <div style={{ padding: '16px', borderBottom: '1px solid #f2f4f7' }}>
                    <div style={{ fontWeight: 600, fontSize: 14, color: '#101828' }}>{user?.name}</div>
                    <div style={{ fontSize: 12, color: '#667085', marginTop: 2 }}>{user?.email}</div>
                  </div>
                  <div style={{ padding: '8px' }}>
                    <div className="dropdown-item" onClick={() => { setUserMenuOpen(false); setShowProfileModal(true); }}>
                      <Settings size={16} strokeWidth={1.8} color="#667085" /> Profil & Ayarlar
                    </div>
                    <div className="dropdown-item danger" onClick={handleLogout}>
                      <LogOut size={16} strokeWidth={1.8} color="#d92d20" /> Çıkış Yap
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="admin-content-area">
          <div style={{ flex: 1 }}>
            {children}
          </div>
          <div style={{ marginTop: 40, paddingTop: 20, borderTop: '1px solid #eaecf0', textAlign: 'center' }}>
            <div style={{ fontSize: 12, color: '#98a2b3', fontWeight: 600 }}>Eğitim ve Akademi Şefliği</div>
            <div style={{ fontSize: 11, color: '#d0d5dd', marginTop: 4 }}>© 2026 Petlas A.Ş. — Tüm hakları saklıdır.</div>
          </div>
        </div>
      </div>

      {/* Profil Modal */}
      {showProfileModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(16,24,40,0.5)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: 20 }}>
          <div className="modal-container">
            <div style={{ padding: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #eaecf0' }}>
              <div>
                <div style={{ fontWeight: 600, fontSize: 18, color: '#101828' }}>Şifre Değiştir</div>
                <div style={{ fontSize: 13, color: '#667085', marginTop: 4 }}>Hesap güvenliğinizi yönetin</div>
              </div>
              <button className="modal-close-btn" onClick={() => { setShowProfileModal(false); setProfileMsg(''); }}>
                <X size={18} />
              </button>
            </div>
            <div style={{ padding: '24px' }}>
              {profileMsg && <div style={{ background: profileMsg.startsWith('✓') ? '#ecfdf3' : '#fef3f2', border: `1px solid ${profileMsg.startsWith('✓') ? '#abefc6' : '#fecdca'}`, borderRadius: 8, padding: '12px 16px', marginBottom: 20, fontSize: 13, fontWeight: 500, color: profileMsg.startsWith('✓') ? '#027a48' : '#b42318' }}>{profileMsg}</div>}
              {[['currentPassword','Mevcut Şifre'],['newPassword','Yeni Şifre'],['confirmPassword','Yeni Şifre (Tekrar)']].map(([key, label]) => (
                <div key={key} style={{ marginBottom: 16 }}>
                  <label style={{ display: 'block', marginBottom: 6, fontWeight: 500, fontSize: 13, color: '#344054' }}>{label}</label>
                  <input type="password" className="modal-input" value={profileForm[key]} onChange={e => setProfileForm({...profileForm, [key]: e.target.value})} />
                </div>
              ))}
              <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
                <button className="modal-btn-cancel" onClick={() => { setShowProfileModal(false); setProfileMsg(''); }}>İptal</button>
                <button className="modal-btn-save" onClick={changePassword} disabled={savingProfile}>
                  {savingProfile ? 'Kaydediliyor...' : 'Kaydet'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Çıkış Onay Modal */}
      {showLogoutConfirm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(16,24,40,0.5)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 20 }}>
          <div className="modal-container text-center" style={{ padding: '24px', maxWidth: 400 }}>
            <div className="logout-warning-icon">
              <LogOut size={24} color="#d92d20" />
            </div>
            <div style={{ fontWeight: 600, fontSize: 18, color: '#101828', marginBottom: 8 }}>Çıkış Yap</div>
            <div style={{ fontSize: 14, color: '#667085', marginBottom: 24, lineHeight: 1.5 }}>Yönetim panelinden güvenli bir şekilde çıkış yapmak istediğinize emin misiniz?</div>
            <div style={{ display: 'flex', gap: 12 }}>
              <button className="modal-btn-cancel" onClick={() => setShowLogoutConfirm(false)}>Vazgeç</button>
              <button className="modal-btn-danger" onClick={doLogout}>Evet, Çıkış Yap</button>
            </div>
          </div>
        </div>
      )}

      {/* CSS Animasyonları ve Kurumsal Menü Teması */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');

        * {
          -webkit-font-smoothing: antialiased;
          font-family: 'Poppins', sans-serif;
        }

        /* Sidebar Toggle Butonu */
        .sidebar-toggle-btn {
          background: #f9fafb; border: 1px solid #eaecf0; cursor: pointer; margin-left: auto;
          color: #667085; padding: 6px; border-radius: 8px; display: flex; align-items: center;
          transition: all 0.3s cubic-bezier(0.2, 0, 0, 1);
        }
        .sidebar-toggle-btn:hover { background: #f3f4f6; color: #1e293b; border-color: #e5e7eb; transform: scale(1.05); }

        /* Ana Menü Öğeleri */
        .petlas-menu-item {
          position: relative; padding: 10px 12px; display: flex; align-items: center; gap: 12px;
          cursor: pointer; border-radius: 10px; margin-bottom: 4px; background: transparent;
          color: #475467; font-weight: 500; font-size: 13.5px; border: 1px solid transparent;
          transition: all 0.3s cubic-bezier(0.2, 0, 0, 1);
        }
        .petlas-menu-item.collapsed { padding: 10px; justify-content: center; }

        /* HOVER: Açık Gri Zemin, Koyu Metin */
        .petlas-menu-item:hover { background: #f8fafc; color: #0f172a; transform: translateX(4px); }
        .petlas-menu-item.collapsed:hover { transform: translateY(-2px); }

        /* AKTİF MENÜ: Açık Gri Zemin, Koyu Metin, Bold */
        .petlas-menu-item.active { background: #f1f5f9; color: #0f172a; font-weight: 600; transform: translateX(0); }
        .petlas-menu-item.active:hover { transform: translateX(2px); }

        /* Aktif Menü Çizgisi (SADECE BU KIRMIZI) */
        .active-indicator {
          position: absolute; left: 0; top: 50%; transform: translateY(-50%); width: 4px; height: 24px;
          background: #e30613; border-radius: 0 4px 4px 0;
        }

        /* Menü İkonları */
        .petlas-menu-icon {
          padding: 6px; border-radius: 8px; display: flex; align-items: center; justify-content: center;
          background: transparent; color: inherit; transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        /* Aktif olanın İkonu beyaz zeminli, gölgeli ve koyu renk (mavi iptal) */
        .petlas-menu-item.active .petlas-menu-icon {
          background: #ffffff; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); color: #0f172a;
        }
        .petlas-menu-item:hover .petlas-menu-icon { transform: scale(1.1) rotate(-3deg); }
        .petlas-menu-item.active:hover .petlas-menu-icon { transform: scale(1.05) rotate(0deg); }

        /* Menü Label */
        .petlas-menu-label { flex: 1; letter-spacing: -0.2px; white-space: nowrap; }

        /* Chevron Animasyonu */
        .submenu-chevron { color: #98a2b3; transition: transform 0.3s cubic-bezier(0.2, 0, 0, 1); }
        .petlas-menu-item.active .submenu-chevron { color: #0f172a; }
        .submenu-chevron.open { transform: rotate(180deg); }

        /* Alt Menü Container */
        .petlas-submenu-container {
          margin-left: 26px; margin-bottom: 8px; padding-left: 12px; border-left: 1px solid #eaecf0;
          animation: slideDown 0.3s cubic-bezier(0.2, 0, 0, 1) forwards;
        }
        @keyframes slideDown { from { opacity: 0; transform: translateY(-5px); } to { opacity: 1; transform: translateY(0); } }

        /* Alt Menü Öğeleri */
        .petlas-submenu-item {
          position: relative; padding: 8px 12px; display: flex; align-items: center; gap: 10px; cursor: pointer;
          border-radius: 8px; margin-bottom: 2px; background: transparent; color: #667085; font-weight: 500;
          font-size: 13px; transition: all 0.3s cubic-bezier(0.2, 0, 0, 1);
        }
        /* Alt Menü Hover (Açık Gri) */
        .petlas-submenu-item:hover { background: #f8fafc; color: #0f172a; transform: translateX(4px); }
        /* Alt Menü Aktif (Açık Gri Zemin, Koyu Metin) */
        .petlas-submenu-item.active { background: #f1f5f9; color: #0f172a; font-weight: 600; }
        .petlas-submenu-item.active:hover { transform: translateX(2px); }

        .submenu-dot { width: 5px; height: 5px; border-radius: 50%; background: #d0d5dd; flex-shrink: 0; transition: all 0.3s; }
        .petlas-submenu-item.active .submenu-dot { background: #e30613; transform: scale(1.2); }
        .petlas-submenu-item:hover .submenu-dot { background: #9ca3af; }
        .petlas-submenu-item.active:hover .submenu-dot { background: #e30613; }

        /* Footer & Topbar Kullanıcı Kartı (Kırmızı Avatar) */
        .sidebar-user-card {
          background: #ffffff; border: 1px solid #eaecf0; border-radius: 12px; padding: 10px 12px;
          margin-bottom: 10px; display: flex; align-items: center; gap: 10px; transition: all 0.3s;
        }
        .sidebar-user-card:hover { border-color: #d0d5dd; box-shadow: 0 2px 4px rgba(16,24,40,0.02); }

        .sidebar-user-avatar, .topbar-user-avatar {
          background: #fff1f2; color: #e30613; display: flex; align-items: center; justify-content: center; font-weight: 700;
        }
        .sidebar-user-avatar { width: 34px; height: 34px; border-radius: 10px; font-size: 14px; flex-shrink: 0; }
        .topbar-user-avatar { width: 26px; height: 26px; border-radius: 6px; font-size: 12px; }

        /* Çıkış Yap Butonu */
        .sidebar-logout-btn {
          padding: 10px 12px; display: flex; align-items: center; gap: 12px; cursor: pointer; border-radius: 10px;
          color: #d92d20; font-size: 13.5px; font-weight: 600; transition: all 0.3s cubic-bezier(0.2, 0, 0, 1);
        }
        .logout-icon-wrapper {
          background: #fef3f2; padding: 4px; border-radius: 8px; display: flex; align-items: center; justify-content: center;
          transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        .sidebar-logout-btn:hover { background: #fef3f2; transform: translateY(-1px); }
        .sidebar-logout-btn:hover .logout-icon-wrapper { transform: scale(1.1) rotate(5deg); background: #fee4e2; }

        /* Topbar Stilleri */
        .admin-topbar {
          height: 64px; background: rgba(255,255,255,0.9); backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px);
          border-bottom: 1px solid #eaecf0; display: flex; align-items: center; justify-content: space-between;
          padding: 0 24px; gap: 12px; position: sticky; top: 0; z-index: 100;
        }
        .mobile-menu-btn {
          background: #ffffff; border: 1px solid #eaecf0; cursor: pointer; padding: 8px; border-radius: 8px;
          color: #344054; display: flex; align-items: center; box-shadow: 0 1px 2px rgba(16,24,40,0.05); transition: all 0.2s;
        }
        .mobile-menu-btn:hover { background: #f9fafb; color: #101828; }

        .topbar-refresh-btn {
          background: #ffffff; border: 1px solid #eaecf0; border-radius: 8px; width: 38px; height: 38px; cursor: pointer;
          display: flex; align-items: center; justify-content: center; font-size: 18px; color: #667085;
          box-shadow: 0 1px 2px rgba(16,24,40,0.05); transition: all 0.3s;
        }
        .topbar-refresh-btn:hover { background: #f9fafb; color: #101828; transform: rotate(45deg); }

        .topbar-user-card {
          display: flex; align-items: center; gap: 10px; cursor: pointer; padding: 6px 12px; border-radius: 10px;
          border: 1px solid #eaecf0; background: #ffffff; box-shadow: 0 1px 2px rgba(16,24,40,0.05); transition: all 0.3s;
        }
        .topbar-user-card:hover { border-color: #d0d5dd; background: #f9fafb; }

        .topbar-dropdown {
          position: absolute; top: 52px; right: 0; background: #ffffff; border-radius: 12px; border: 1px solid #eaecf0;
          box-shadow: 0 12px 24px rgba(16,24,40,0.08); width: 220px; z-index: 300; overflow: hidden;
          animation: dropFade 0.2s cubic-bezier(0.2, 0, 0, 1); transform-origin: top right;
        }
        @keyframes dropFade { from { opacity: 0; transform: scale(0.95) translateY(-5px); } to { opacity: 1; transform: scale(1) translateY(0); } }

        .dropdown-item {
          padding: 10px 12px; display: flex; align-items: center; gap: 10px; cursor: pointer; border-radius: 8px;
          font-size: 13px; color: #344054; font-weight: 500; transition: all 0.2s;
        }
        .dropdown-item:hover { background: #f9fafb; transform: translateX(2px); }
        .dropdown-item.danger { color: #d92d20; }
        .dropdown-item.danger:hover { background: #fef3f2; }

        /* İçerik Alanı Fade Animasyonu */
        .admin-content-area {
          flex: 1; overflow: auto; padding: 24px; display: flex; flex-direction: column;
          animation: contentFadeIn 0.5s ease;
        }
        @media (max-width: 768px) { .admin-content-area { padding: 16px; } }
        @keyframes contentFadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }

        /* Modal Ortak Stiller */
        .modal-container {
          background: #ffffff; border-radius: 16px; width: 100%; max-width: 420px;
          box-shadow: 0 20px 24px -4px rgba(16,24,40,0.08), 0 8px 8px -4px rgba(16,24,40,0.03);
          overflow: hidden; animation: modalPop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        @keyframes modalPop { from { opacity: 0; transform: scale(0.9); } to { opacity: 1; transform: scale(1); } }

        .modal-close-btn {
          background: #f9fafb; border: 1px solid #eaecf0; border-radius: 8px; width: 36px; height: 36px;
          cursor: pointer; display: flex; align-items: center; justify-content: center; color: #667085; transition: all 0.2s;
        }
        .modal-close-btn:hover { background: #f2f4f7; color: #101828; transform: rotate(90deg); }

        .modal-input {
          width: 100%; padding: 10px 14px; border: 1px solid #d0d5dd; border-radius: 8px; font-size: 14px; outline: none;
          box-sizing: border-box; box-shadow: 0 1px 2px rgba(16,24,40,0.05); color: #101828; transition: all 0.3s;
        }
        .modal-input:focus { border-color: #e30613; box-shadow: 0 0 0 4px #fff1f2; }

        .modal-btn-cancel {
          flex: 1; padding: 10px 16px; border: 1px solid #d0d5dd; border-radius: 8px; background: #ffffff; cursor: pointer;
          font-weight: 600; font-size: 14px; color: #344054; box-shadow: 0 1px 2px rgba(16,24,40,0.05); transition: all 0.2s;
        }
        .modal-btn-cancel:hover { background: #f9fafb; border-color: #d0d5dd; }

        .modal-btn-save {
          flex: 1; padding: 10px 16px; border: 1px solid #e30613; border-radius: 8px; background: #e30613; color: #ffffff;
          cursor: pointer; font-weight: 600; font-size: 14px; box-shadow: 0 1px 2px rgba(16,24,40,0.05); transition: all 0.2s;
        }
        .modal-btn-save:hover { background: #ba000a; border-color: #ba000a; transform: translateY(-1px); }

        .modal-btn-danger {
          flex: 1; padding: 10px 16px; border: 1px solid #d92d20; border-radius: 8px; background: #d92d20; color: #ffffff;
          cursor: pointer; font-weight: 600; font-size: 14px; transition: all 0.2s;
        }
        .modal-btn-danger:hover { background: #b42318; border-color: #b42318; transform: translateY(-1px); }

        .logout-warning-icon {
          width: 48px; height: 48px; border-radius: 50%; background: #fee4e2; display: flex; align-items: center;
          justify-content: center; margin: 0 auto 16px; border: 8px solid #fef3f2;
        }

        /* Scrollbar */
        .sidebar-nav::-webkit-scrollbar { width: 4px; }
        .sidebar-nav::-webkit-scrollbar-track { background: transparent; }
        .sidebar-nav::-webkit-scrollbar-thumb { background: #eaecf0; border-radius: 4px; }
        .sidebar-nav::-webkit-scrollbar-thumb:hover { background: #d0d5dd; }
        @media (max-width: 768px) { .hide-on-mobile { display: none; } }
      `}</style>
    </div>
  );
}
